export default __webpack_public_path__ + "4c077866721e0516da59efb50de0fcf4.svg";